import React from 'react';
import './App.css';
import title from './Images/title.png';
import discord from './Images/discord.webp';
import kofi from './Images/kofi.webp';
import FooterCarousel from './footercarousel';

function App() {
  return (
    <div className="app-container">
      <div className="hero-section">
        <div className="hero-content">
          <img src={title} className="title" alt="Title" />
        </div>

        <div className="top-nav">
          <div className="nav-links">
            <div
              className="nav-item"
              onClick={() => window.location.href = 'https://discord.gg/8sh64DZ8e9'}
            >
              <img src={discord} className="nav-icon" alt="Discord" />
              <span>Discord</span>
            </div>
            <div
              className="nav-item"
              onClick={() => window.location.href = 'https://ko-fi.com/'}
            >
              <img src={kofi} className="nav-icon" alt="Ko-fi" />
              <span>Donate</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-section">
        <h2 className="slogan">"Insert Slogan Here"</h2>
        <div className="carousel-wrapper">
          <FooterCarousel />
        </div>
      </div>


      <a href="https://discord.gg/8sh64DZ8e9" className="join-banner">
        Join and get whitelisted today!
      </a>
    </div>
  );
}

export default App;
